import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLockBodyScroll } from 'src/hooks/useLockBodyScroll';

import s from './PortalModal.module.scss';

function PortalModal({
  children,
  onClickForClose,
  className = '',
  portalClassName = '',
  overlayClassName = '',
}: {
  children: React.ReactNode;
  onClickForClose: () => void;
  className?: string;
  overlayClassName?: string;
  portalClassName?: string;
}) {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  useEffect(() => {
    function onEscapePressed(event: KeyboardEvent) {
      if (event.key === 'Escape') onClickForClose();
    }

    document.addEventListener('keydown', onEscapePressed);

    return () => {
      document.removeEventListener('keydown', onEscapePressed);
    };
  }, [onClickForClose]);

  useLockBodyScroll();

  const contentWrapper = (
    <div className={cn(s.root, portalClassName)}>
      <div
        className={cn(s.overlay, overlayClassName)}
        onClick={onClickForClose}
      />
      <div className={className}>{children}</div>
    </div>
  );

  if (isBrowser) {
    const container = document.getElementById('portal-calc') as Element;
    return createPortal(contentWrapper, container);
  }

  // TODO: c-portal-modal_hidden наверно нужно заюзать свой
  return <div className="c-portal-modal_hidden" />;
}

export { PortalModal };
